import { useState, useEffect } from 'react'

const useGetImgPlacements = (imgPlacement) => {
    const [imgPlacements, setImgPlacements] = useState({})

    useEffect(() => {
        const imgBackground = imgPlacement === 'background'
        const imgTop = imgPlacement === 'top'
        const imgBottom = imgPlacement === 'bottom'
        const imgLeft = imgPlacement === 'left'
        const imgRight = imgPlacement === 'right'
        const imgLeftOrRight = imgLeft || imgRight

        setImgPlacements({
            imgTop,
            imgBottom,
            imgLeft,
            imgRight,
            imgLeftOrRight,
            imgBackground,
        })
    }, [imgPlacement])

    return imgPlacements
}

export default useGetImgPlacements